import { Menu } from "lucide-react";
import { NAV } from "@/data/site";

export const DesktopNav = ({ onGo }) => (
    <nav className="hidden items-center gap-8 lg:flex" aria-label="Navigazione principale">
        {NAV.map((item) => (
            <button
                key={item.id}
                type="button"
                data-testid={`nav-link-${item.id}`}
                onClick={() => onGo(item)}
                className="group relative font-mono-tl text-xs uppercase tracking-[0.2em] text-white/70 transition-colors duration-300 hover:text-white"
            >
                {item.label}
                <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-tl-orange transition-[width] duration-300 group-hover:w-full" />
            </button>
        ))}
    </nav>
);

export const HeaderActions = ({ onGo, onOpenMenu }) => (
    <div className="flex items-center gap-3">
        <button
            type="button"
            data-testid="header-quote-button"
            onClick={() => onGo("contatti")}
            className="hidden bg-tl-orange px-5 py-2.5 font-mono-tl text-xs font-semibold uppercase tracking-[0.15em] text-tl-dark transition-colors duration-300 hover:bg-tl-orangeHover sm:block"
        >
            Richiedi un preventivo
        </button>
        <button
            type="button"
            data-testid="mobile-menu-trigger"
            onClick={onOpenMenu}
            className="grid h-11 w-11 place-items-center border border-white/15 text-white lg:hidden"
            aria-label="Apri menu"
        >
            <Menu size={20} />
        </button>
    </div>
);
